/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState, useRef } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
import { useLocation } from 'react-router';
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import {
  caseEditAction,
  caseResetAction,
  caseSearchAction,
} from "../case-container/actions/CaseActions";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import OpenNewTabLink from "src/components/OpenNewTabLink";
import { userSearchAPI } from "src/api/UserApi";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
  ProductCategoryTypesData,
  RC_TRANSFERRED_BY_TYPES_LIST,
  DAYS_COUNT_TYPES_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CommissionManagerDropDown from "src/business-components/CommissionManagerDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { PAYOUT } from "../company-container/CompanyConstants";
import FormikCheckBox from "src/components/formik/FormikCheckBox";
import { caseInvoiceCreateAPI } from "src/api/CaseApi";
import LinkComponent from "src/components/LinkComponent";
import { Route, Switch } from "react-router-dom";
import Invoice from "./Invoice";
import { useHistory } from "react-router";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { commissionSearchAPI } from "src/api/CommissionApi";
import CustomerDropDown from "src/business-components/CustomerDropDown";
import FormikInput from "src/components/formik/FormikInput";
import { getGSTCalc, getPayout, getTotalAmount } from "src/utils/CommonUtils";
import { EMPLOYMENT_TYPES_LIST } from "../user-container/UserConstants";
import { DATA_TYPE, DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { remarkSearchAPI } from "src/api/RemarkApi";
import { ExportReactCSV } from "src/components/excel/ExportReactCSV";
import FormikToggle from "src/components/formik/FormikToggle";
import { excelCaseSearchAction } from "../excel-container/actions/ExcelActions";

const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    values,
    activityList,
    userType,
    ExportInExcel,
    handleChange,
    generateInvoice,
    history,
    onPageChange,
    alertModalClass,
    alertDisplay,
    openAlertDialog,
    viewRemarks,
    editClick,
  } = props;

  return (
    <div>
      <div style={{ justifyContent: 'center', display: 'flex', padding: '20px' }}><h2>RC PDD Report</h2></div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              {/* <div className="form-group col-md-3">
                <label>Category</label>
                <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  name="productCategory"
                  className="form-control"
                />
              </div>  */}
              {/* {values.productCategory === "CAR_LOAN" && ( */}
              <div className="form-group col-md-3">
                <label>Loan Type</label>
                <FormikSelect
                  items={CAR_LOAN_TYPE_LIST}
                  name="loanType"
                  className="form-control"
                  initialValue="Used"
                />
              </div>
              {/* )}  */}
              {values.productCategory === "CAR_LOAN" && values.loanType === "USED" && (
                <div className="form-group col-md-3">
                  <label>Used Car Loan Type</label>
                  <FormikSelect
                    items={USED_CAR_LOAN_TYPE_LIST}
                    name="usedCarLoanType"
                    className="form-control"
                  />
                </div>
              )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={!!values.FilterCommissionId || !!values.by}
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={!!values.FilterCommissionId || !!values.by}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown name="companyId" value={values.companyId} />
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId" value={values.agentId} />
              </div>
              <div className="form-group col-md-3">
                <label>Reporting Manager</label>
                <UserDropDown name="reportingManagerId" value={values.reportingManagerId} />
              </div>

              <div className="form-group col-md-5">
                <label>Customer</label>
                <CustomerDropDown name="customerId" value={values.customerId} />
              </div>
              <div className="form-group col-md-3">
                <label>Vehicle Number</label>
                <FormikInput
                  name="vehicleNumber"
                  type="text"
                  placeholder="enter Vehicle Number for filter e.g DLB64620"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={EMPLOYMENT_TYPES_LIST}
                  name="employmentType"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Loan Acc/Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="Loan Acc/Policy Number"
                  value={values.LoanPolicyNumber}
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>RC Transferred by </label>
                <FormikSelect
                  items={RC_TRANSFERRED_BY_TYPES_LIST}
                  name="rcTransferredBy"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Name </label>
                <UserDropDown
                  name="rcTransferredByNameId"
                  value={values.rcTransferredByNameId}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Data entry operater</label>
                <UserDropDown
                  name="by"
                  value={values.by}
                />
              </div>
              {values.by && (
                <>
                  <div className="form-group col-md-3">
                    <label>From Date</label>
                    <FormikDateTimePicker
                      name="CaseTsFromDate"
                      className="form-control"
                      disableClock
                      format="dd-MM-y"
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label>To Date</label>
                    <FormikDateTimePicker
                      name="CaseTsToDate"
                      className="form-control"
                      disableClock
                      format="dd-MM-y"
                    />
                  </div>
                </>
              )}
              <div className="form-group col-md-3">
                <label>Days Count </label>
                <FormikSelect
                  items={DAYS_COUNT_TYPES_LIST}
                  name="daysOrder"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3 pt-4 mt-2">
                <label>Parivahan status ?</label>
                <FormikToggle name="parivahanStatus" value={values.parivahanStatus} />
              </div>
            </div>

            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="reports.rc_pdd_report.search"
              />
            </div>
          </Form>
        </div>
      </div>
      <div className="border-top my-3" />
      <div className="card mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"RC-PDD-Report-" + new Date().toLocaleDateString()}
            />
          </h5>
          <Table
            recordsPerPage={50}
            onPageChange={onPageChange}
            searchData={{
              data: activityList.data,
              count: activityList.count,
              currentPage: activityList.currentPageIndex,
            }}
            columns={{
              group: [
                // {
                //   display: "Policy Number",
                //   path: "coverNotes.cn_number",
                // }, 
                // {
                //   display: "Dealer/Showroom",
                //   path: "meta.showroomDealer.companyDisplayName",
                // }, 
                {
                  display: "Name of Customer",
                  path: "customerName",
                },
                // {
                //   display: "Customer Mobile",
                //   path: "customerId.phone",
                // },
                {
                  display: "Vehicle Number",
                  path: "meta.vehicleNumber",
                },
                {
                  display: "Chasis Number",
                  path: "meta.chasisNumber",
                },
                {
                  display: "Engine Number",
                  path: "meta.engineNumber",
                },
                {
                  display: "Disbursal Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "meta.loanDate",
                },
                {
                  display: "Day Count",
                  path: "dayCount",
                },
                {
                  display: 'Loan Amount',
                  type: DATA_TYPE.Decimal,
                  path: 'amount',
                },
                {
                  display: "Assigned Agent Name",
                  path: "agentName",
                },
                {
                  display: "RC Transferred by",
                  path: "rcTransferredBy",
                },
                {
                  display: "RC Transferred Name",
                  path: ["rcTransferredByNameId.personalInfo.firstName", "rcTransferredByNameId.personalInfo.lastName", "rcTransferredByNameId.personalInfo.phone"]
                },
                {
                  display: "Bank/Company Name",
                  path: "companyId.companyName",
                },
                {
                  display: "RC Received",
                  path: "meta.RCRecv",
                },
                {
                  display: "Parivahan Status",
                  path: "meta.parivahanStatus",
                },
                {
                  display: "RTO Slip Received",
                  path: "meta.rtoSlip",
                },
                {
                  display: "Created By",
                  path: "by.personalInfo.firstName",
                },
                {
                  display: "Ts",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "ts"
                },
                {
                  display: "Updated By",
                  path: "updatedBy.personalInfo.firstName",
                },

                {
                  display: "Updated Ts",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "updatedTs"
                },
                // {
                //   display: "Invoice Received",
                //   path: "meta.invoiceRecv",
                // },

                // {
                //   display: "Co Applicant",
                //   path: ["CoApplicantDetails[0].customerId.firstName", "CoApplicantDetails[0].customerId.lastName", "CoApplicantDetails[0].customerId.phone"]
                // },
                // {
                //   display: "Model Name",
                //   path: "meta.vehicleProductId.productName",
                // },
                // {
                //   display: "Cost Of Asset",
                //   path: "meta.costOfAsset",
                // },
                //

                // {
                //   display: "Insurance Received",
                //   path: "meta.insuranceRec",
                // },
                // {
                //   display: "Reporting Manager Name",
                //   path: ["reportingManagerId.personalInfo.firstName", "reportingManagerId.personalInfo.lastName", "reportingManagerId.personalInfo.phone"],
                // },       
                // {
                //   display: 'Payment Amount',
                //   path: 'paymentAmount',
                // },
                // {
                //   display: 'Receipt Amount',
                //   path: 'receiptAmount',
                // },

                // {
                //   display: 'Agent Payout Rate(%)',
                //   path: 'agentCommissionPercentage',
                // },
                // {
                //   display: 'Payout Amount',
                //   path: 'payoutAmount',
                // }, 
                // {
                //   display: 'Bank Payment Rate',
                //   path: 'companyCommissionPercentage',
                // },
                // {
                //   display: 'Due Amount',
                //   path: 'DueAmount',
                // },
                // {
                //   display: 'GST(Inc/Exc)',
                //   path: 'GSTEncExc',
                // },
                // {
                //   display: 'Difference',
                //   path: 'difference',
                // },
              ],
            }}
            rowColoring={[
              // list should be priority wise
              {
                reason: 'Pending',
                rowClass: 'status-pending',
                shouldApply: (record) => (record.isPending),
              },
              {
                reason: 'Critical',
                rowClass: 'status-critical',
                shouldApply: (record) => (record.isCritical),
              },
            ]}
            customActions={[
              {
                heading: "View Remarks",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => viewRemarks(record._id)}>
                      <i className="fas fa-eye " />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Case Manager",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => editClick(record)}>
                      <i className="fas fa-pen" />
                    </LinkComponent>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // activityList: PropTypes.Object.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
  verifierId: "",
  clientId: "",
  branchId: "",
  CaseFromDate: null, //new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseToDate: null, //new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  parivahanStatus: false,
  LoanPolicyNumber: ""
};

const RcPddList = () => {
  const [filterInitialValues, setFilterInitialValues] = useState({
    ...filterDefaultValues,
  });

  const [currentProductCategory, setProductCategory] = useState(ProductCategoryTypesData.VEHICLE_INSURANCE);

  const [currentCompany, setCurrentCompany] = useState();

  const [currentActivityAssignedDateTill, setCurrentActivityAssignedDateTill] =
    useState();

  const [currentActivityAssignedDateFrom, setCurrentActivityAssignedDateFrom] =
    useState();

  const [invoiceInitialValues, setInvoiceInitialValues] = useState([]);

  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [alertModalClass, setAlertModalClass] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState(false);

  const [remarksModalClass, setRemarksModalClass] = useState(false);
  const [remarksDisplay, setRemarksDisplay] = useState(false);
  const [remarksDetails, setRemarksDetails] = useState([]);
  const [order, setOrder] = useState(0) //0 for ascending(smaller -> larger),1 for descending(larger -> smaller)
  const [commissionMaster, setCommissionMaster] = useState({ slab: [] });

  const openAlertDialog = () => {
    setRemarksDisplay("block");
    setRemarksModalClass("show");
    if (document.body.style.overflow !== "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };
  const closeAlertDialog = () => {
    setRemarksModalClass("none");
    setRemarksDisplay("");
    if (document.body.style.overflow !== "scroll") {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
  };

  let data = [];
  // REDUX
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isRenualAlert = (location.pathname.split("/").pop() === "insurance-renewal-alert") ? true : false;

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.CaseReducer, shallowEqual);

  const {
    search: { data: excelSearchResults, excelCount },
  } = useSelector((state) => state.ExcelReducer, shallowEqual);


  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );

  const getCommissionDetails = (totalGrossAmt) => {
    let commissionDT = []; //{ commissionTarget: 0, tillNow: 0, Status: "Short" };
    commissionMaster.slab.map((slab, index) => {
      // const lastTarget = commissionMaster.slab[index];
      const status = totalGrossAmt >= slab.target ? "Completed" : "Short";
      const amount = slab.target + (slab.target * slab.reward) / 100;
      commissionDT.push({
        commissionTarget: slab.target,
        tillNow: totalGrossAmt,
        reward: slab.reward,
        amount,
        status,
        isRewardPercentage: slab.isRewardPercentage,
      });
    });
    return commissionDT;
  };

  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }
    const PrepairData = [];
    let totalGrossAmt = 0;
    searchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo?.agentId?.personalInfo?.firstName +
        " " +
        caseInfo?.agentId?.personalInfo?.lastName +
        "-" +
        caseInfo?.agentId?.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const currentDate = new Date();
      const otherDate = new Date(caseInfo.meta.loanDate);
      const timeDifference = Math.abs(currentDate.getTime() - otherDate.getTime());
      const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24));

      const isPending = ((
        !caseInfo.meta.RCRecv ||
        // !caseInfo.meta.insuranceRec ||
        // !caseInfo.meta.invoiceRecv ||
        !caseInfo.meta.parivahanStatus ||
        !caseInfo.meta.rtoSlip) && (
          ((new Date() - new Date(caseInfo.meta.loanDate)) >= 30 * 24 * 60 * 60 * 1000) &&
          ((new Date() - new Date(caseInfo.meta.loanDate)) <= 60 * 24 * 60 * 60 * 1000))
      );
      const isCritical = ((
        !caseInfo.meta.RCRecv ||
        // !caseInfo.meta.insuranceRec ||
        // !caseInfo.meta.invoiceRecv ||
        !caseInfo.meta.parivahanStatus ||
        caseInfo.meta.rtoSlip) && (
          ((new Date() - new Date(caseInfo.meta.loanDate)) >= 61 * 24 * 60 * 60 * 1000))
      );

      PrepairData.push({
        ...caseInfo,
        difference,
        payoutAmount,
        DueAmount,
        CrossSellAmount,
        GSTEncExc,
        agentName,
        amount,
        paymentAmount,
        receiptAmount,
        loanType,
        customerName,
        isPending,
        isCritical,
        dayCount
      });
    });

    // Sort PrepairData based on dayCount and the specified order
    PrepairData.sort((a, b) => {
      const dayCountA = a.dayCount;
      const dayCountB = b.dayCount;

      if (order === 0) { // 0 for ascending
        return dayCountA - dayCountB;
      } else if (order === 1) { // 1 for descending
        return dayCountB - dayCountA;
      }
      return 0;
    });
    const commissionDetails = getCommissionDetails(totalGrossAmt);
    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
      commissionDetails,
    };

    return results;
  }, [
    searchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
    currentPageIndex,
    order,
  ]);

  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        caseSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      caseSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values, formikUtils) => {
      formikUtils.setSubmitting(false);
      const {
        productCategory,
        loanType,
        usedCarLoanType,
        CaseFromDate,
        CaseToDate,
        companyId,
        agentId,
        reportingManagerId,
        FilterCommissionId,
        customerId,
        vehicleNumber,
        employmentType,
        LoanPolicyNumber,
        rcTransferredBy,
        rcTransferredByNameId,
        parivahanStatus,
        daysOrder,
        by,
        CaseTsFromDate,
        CaseTsToDate
      } = values;

      if (
        // THERE MUST BE AT LEAST ONE FILTER
        [
          productCategory,
          loanType,
          usedCarLoanType,
          CaseFromDate,
          CaseToDate,
          companyId,
          FilterCommissionId,
          agentId,
          reportingManagerId,
          customerId,
          vehicleNumber,
          employmentType,
          LoanPolicyNumber,
          rcTransferredBy,
          rcTransferredByNameId,
          parivahanStatus,
          by,
          CaseTsFromDate,
          CaseTsToDate
        ].filter((item) => !!item).length < 1
      ) {
        dispatch(
          headerShowAction({
            data: "There must at least one filter to be added(Excluding Days Count).",
          })
        );
        return;
      }

      let where = {};

      // product Category
      if (productCategory) {
        set(where, "productCategory", productCategory);
        setProductCategory(productCategory);
      } else {
        setProductCategory(null);
      }
      // set(where, "productCategory", "VEHICLE_INSURANCE");

      if (loanType) {
        set(where, "meta.loanType", loanType)
      }
      if (usedCarLoanType)
        set(where, "meta.usedCarType", usedCarLoanType)
      // company
      if (companyId) {
        set(where, "companyId", companyId);
        setCurrentCompany(companyId);
      } else {
        setCurrentCompany(null);
      }

      // FROM
      if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateFrom(CaseFromDate);
        set(where, "meta.loanDate", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }

      // TILL
      if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
        const tillDate = getEndOfDay(CaseToDate);
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateTill(CaseToDate);

        set(where, "meta.loanDate", { $lte: tillDate });
        if (fromDate)
          set(where, "meta.loanDate", { $lte: tillDate, $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      // CLIENT
      if (agentId) {
        where.agentId = agentId;
      }
      if (reportingManagerId) {
        where.reportingManagerId = reportingManagerId;
      }
      //CUSTOMER
      if (customerId) {
        where.customerId = customerId;
      }
      //vehicleNumber
      if (vehicleNumber) {
        set(where, "meta.vehicleNumber", vehicleNumber);
      }
      //RC Transferred BY
      if (rcTransferredBy) {
        set(where, 'rcTransferredBy', rcTransferredBy)
      }
      // days sorting order
      if (daysOrder) {
        console.log("daysOrder", daysOrder);

        // Set the order state based on daysOrder
        if (daysOrder === "ascending") {
          setOrder(0); // 0 for ascending
        } else if (daysOrder === "descending") {
          setOrder(1); // 1 for descending
        }
      }
      //RC Transferred BY Name
      if (rcTransferredByNameId) {
        where.rcTransferredByNameId = rcTransferredByNameId
      }
      //ParivahanStatus
      if (parivahanStatus) {
        set(where, "meta.parivahanStatus", parivahanStatus);
      }
      if (by) {
        set(where, "by", by);
      }
 //ts from
      if (CaseTsFromDate && !Number.isNaN(CaseTsFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseTsFromDate);
        setCurrentActivityAssignedDateFrom(CaseTsFromDate);
        console.log('where', where)
        set(where, "ts", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }
      //ts till
      if (CaseTsToDate && !Number.isNaN(CaseTsToDate.getTime())) {
        const tillDate = getEndOfDay(CaseTsToDate);
        const fromDate = CaseTsFromDate && !Number.isNaN(CaseTsFromDate.getTime()) ? getStartOfDay(CaseTsFromDate) : null;

        setCurrentActivityAssignedDateTill(CaseTsToDate);

        if (fromDate) {
          set(where, "ts", { $lte: tillDate, $gte: fromDate });
        } else {
          set(where, "ts", { $lte: tillDate });
        }
      } else {
        setCurrentActivityAssignedDateTill(null);
      }
      // CommissionId
      if (FilterCommissionId) {
        where = {};
        set(where, "invoiceDetails.commissionId", FilterCommissionId);
        const commissionId = { _id: FilterCommissionId };
        let {
          data: {
            data: { data: commissionMasterDT },
          },
        } = await commissionSearchAPI({
          where: {
            ...commissionId,
          },
          autopopulate: false,
        });
        commissionMasterDT = commissionMasterDT[0];
        setCommissionMaster(commissionMasterDT);
        const fromDate = getStartOfDay(commissionMasterDT.FromDate);
        set(where, "ts", { $gte: fromDate });
        setCurrentActivityAssignedDateFrom(fromDate);
        values.CaseFromDate = fromDate;
        const tillDate = getEndOfDay(commissionMasterDT.ToDate);
        set(where, "ts", { $lte: tillDate });
        setCurrentActivityAssignedDateTill(tillDate);
        values.CaseToDate = tillDate;

        if (commissionMasterDT.loanType)
          set(where, "loanType", commissionMasterDT.loanType);
        if (
          commissionMasterDT.loanType == "USED" &&
          commissionMasterDT.usedCarType
        )
          set(where, "usedCarType", commissionMasterDT.usedCarType);
      } else {
        // setCurrentCompany(null);
      }
      if (employmentType) {
        const userType = { employmentType: employmentType };
        const users = await userSearchAPI({ where: userType });

        const userIds = users.data.data.data.map((user) => user._id);
        set(where, "agentId", { $in: userIds });
        // console.log("userType",userType)
      }
      //LoanPolicyNumber
      if (LoanPolicyNumber) {
        if (productCategory === "VEHICLE_INSURANCE")
          set(where, "coverNotes.cn_number", LoanPolicyNumber)
        else
          set(where, "meta.LoanAccountNo", LoanPolicyNumber)
      }

      setWhere(where);
      dispatch(
        excelCaseSearchAction({
          where,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
        })
      );
      dispatch(
        caseSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );



  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const generateInvoice = useCallback(
    async (commissionId) => {
      const payload = {
        commissionId: commissionId,
        data: invoiceInitialValues,
      };
      const invoice = await caseInvoiceCreateAPI(payload);
      closeAlertDialog();
      dispatch(
        headerShowAction({
          data: "Invoice has been created successfully.",
        })
      );
    },
    [invoiceInitialValues]
  );
  const handleChange = useCallback(
    (e) => {
      const id = e.target.name;
      const checked = e.target.value;

      if (checked == "false")
        setInvoiceInitialValues([...invoiceInitialValues, id]);
      else
        setInvoiceInitialValues(
          invoiceInitialValues.filter((item) => {
            return id !== item;
          })
        );

      // setInvoiceInitialValues(id)

      // data.push(id);
      // console.log("checked", checked);
      // console.log("invoiceInitialValues=>", invoiceInitialValues);
      // if()
      // else
      // console.log('invoiceInitialValues=>', invoiceInitialValues, data);

      return data;
    },
    [
      // dispatch,
      invoiceInitialValues,
    ]
  );

  const ExportInExcel = useMemo(() => {
    if (!excelSearchResults) {
      return [];
    }
    const results = [];
    let totalGrossAmt = 0;

    excelSearchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo?.agentId?.personalInfo?.firstName +
        " " +
        caseInfo?.agentId?.personalInfo?.lastName +
        "-" +
        caseInfo?.agentId?.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };
      const formattedDate = new Date(caseInfo.ts).toLocaleDateString('en-GB', dateOptions);
      const formattedLoanDate = new Date(caseInfo.meta.loanDate).toLocaleDateString('en-GB', dateOptions);
      results.push({
        "Loan Date": formattedLoanDate,
        "Name of Customer": customerName,
        "Vehicle Number": caseInfo.meta.vehicleNumber,
        "Chasis Number": caseInfo.meta.chasisNumber,
        "Engine Number": caseInfo.meta.engineNumber,
        "Loan Amount": caseInfo.meta.loanAmount,
        "Assigned Agent Name": agentName,
        "RC Transferred By": caseInfo.rcTransferredBy,
        "RC Transferred Name":
          caseInfo?.rcTransferredByNameId?.personalInfo?.firstName + " " +
          caseInfo?.rcTransferredByNameId?.personalInfo?.lastName + " " +
          caseInfo?.rcTransferredByNameId?.personalInfo?.phone,
        "Bank/Company Name": caseInfo.companyId.companyName,
        "RC Received": caseInfo.meta.RCRecv === true ? 'YES' : 'NO',
        "Parivahan Status": caseInfo.meta.parivahanStatus === true ? 'YES' : 'NO',
        "RTO Slip Received": caseInfo.meta.rtoSlip === true ? 'YES' : 'NO',
        "Created By": caseInfo?.by?.personalInfo?.firstName,
        "Updated By": caseInfo?.updatedBy?.personalInfo?.firstName,
        Date: formattedDate,
      });
    });

    return results;
  }, [
    excelSearchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
  ]);
  const viewRemarks = async (id) => {
    openAlertDialog("remarks");
    if (!id) return;

    let where = {
      refId: id,
      deleted: false,
      source: "cases",
    };

    const {
      data: {
        data: { data: remarks },
      },
    } = await remarkSearchAPI({
      where,
      sortBy: "ts",
      pageLength: 0,
      currentPage: 1,
      autopopulate: false,
    });
    setRemarksDetails(remarks);
  };

  // EDIT
  const editClick = useCallback((record) => {
    dispatch(caseEditAction(record));
    history.push(RoutingUtil.caseManagerUrl());
  }, [
    dispatch,
    caseEditAction,
    history,
  ]);

  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
      // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            activityList={activitiesFromSearch}
            userType={userType}
            ExportInExcel={ExportInExcel}
            handleChange={handleChange}
            generateInvoice={generateInvoice}
            history={history}
            onPageChange={onPageChange}
            alertModalClass={alertModalClass}
            alertDisplay={alertDisplay}
            openAlertDialog={openAlertDialog}
            viewRemarks={viewRemarks}
            editClick={editClick}
          />
        )}
      </Formik>
      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${remarksModalClass}`}
        id="authAlert"
        style={{
          display: `${remarksDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Remarks
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("remarks")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {remarksDetails.map((remark, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{remark.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("remarks")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RcPddList;
